import s from "../form.module.scss";
import React, { AllHTMLAttributes, useCallback, useMemo } from "react";
import cn from "classnames";
import searchIcon from "public/img/icons/sprite/search.svg";
import closeIcon from "public/img/icons/sprite/close.svg";
import { SpriteIcon } from "@/components/UI/SpriteIcon";

type SearchInputProps = {
  searchTerm: string;
  handleSearch: (value: string) => void;
  number?: number;
} & AllHTMLAttributes<HTMLInputElement>;

export const InputSearch = ({ className, handleSearch, searchTerm, number, ...props }: SearchInputProps) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(event.target.value);
  };

  const onClear = useCallback(() => {
    handleSearch("");
  }, [handleSearch]);

  const hasValue = useMemo(() => !!searchTerm?.trim()?.length, [searchTerm]);

  const hasNumber = number !== undefined;

  return (
    <label
      htmlFor="search"
      className={cn(
        s.searchBox,
        {
          [s.withNumber]: hasNumber,
        },
        className
      )}
    >
      <input
        type="search"
        className={cn(s.input, s.searchInput)}
        onChange={onInputChange}
        value={searchTerm}
        {...props}
      />
      {!!number && <span className={s.searchNumber}>{number}</span>}
      {!hasValue && <SpriteIcon icon={searchIcon} className={s.searchIcon} />}
      {hasValue && <SpriteIcon icon={closeIcon} className={s.clearIcon} onClick={onClear} />}
    </label>
  );
};
